"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GO_TO_PREV_MENU = exports.CHANGE_MOBIL_MENU_NAME = exports.CHANGE_MENU_PROPS = exports.CHANGE_MENU_FROM_NAME = exports.SET_MENU = void 0;
exports.SET_MENU = 'SET_MENU';
exports.CHANGE_MENU_FROM_NAME = 'CHANGE_MENU_FROM_NAME';
exports.CHANGE_MENU_PROPS = 'CHANGE_MENU_PROPS';
exports.CHANGE_MOBIL_MENU_NAME = 'CHANGE_MOBIL_MENU_NAME';
exports.GO_TO_PREV_MENU = 'GO_TO_PREV_MENU';
